export const negation = (value: number, negate = true): number => {
  return value && value * Math.sign(negate ? -1 : 1);
};
